import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  otp: yup
    .string()
    .required('Favor ingresar tu código')
    .min(5, 'El código debe tener 5 digitos'),
});